import styled from 'styled-components'

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const TypeName = styled.div`
    font-size: 10px;
    line-height: 20px;
    color: var(--color-gray-500);
`

export const Value = styled.div`
    font-size: 12px;
    line-height: 20px;
    background-color: var(--color-gray-100);
    border-radius: 4px;
    padding: 4px 8px;
`
